import { HexUniTransaction } from '@/service/backend'
import { utils } from 'ethers'
import type { Transaction } from '@unipasswallet/transactions'

export const formatImgUrl = (url: string) => {
  const protocol = url.split('://')[0]
  if (protocol === 'ipfs') {
    return url.replace('ipfs://', 'https://ipfs.io/ipfs/')
  }
  return url
}

export const base64URLFormatter = function (input: string) {
  // Replace non-url compatible chars with base64 standard chars
  if (input) {
    input = input.replace(/-/g, '+').replace(/_/g, '/')
    const pad = input.length % 4
    if (pad) {
      if (pad === 1) {
        throw new Error(
          'InvalidLengthError: Input base64url string is the wrong length to determine padding',
        )
      }
      input += new Array(5 - pad).join('=')
    }
  }
  // Pad out with standard base64 required padding characters
  return input
}

export const UniTransactionParser = function (tx: Transaction): HexUniTransaction {
  return Object.assign(tx, {
    data: tx.data ? utils.hexlify(tx.data) : '',
    gasLimit: tx.gasLimit?.toHexString(),
    target: utils.hexlify(tx.target),
    value: tx.value?.toHexString(),
  })
}
